import React from 'react'
import { css } from 'styled-system/css'
import { PriceText, Text } from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import toCurrency from '@mindfulchefuk/utils/toCurrency'

export const OnboardingCartDrawerTotalPrice = () => {
  const { onboardingOrderPreviewTotals } = useChooseRecipesContext()
  const { total, totalAfterDiscount, shippingPrice } =
    onboardingOrderPreviewTotals

  const isDiscounted = parseFloat(totalAfterDiscount) > 0

  const shippingText =
    parseFloat(shippingPrice) > 0
      ? `incl. ${toCurrency(parseFloat(shippingPrice))} delivery`
      : 'with free delivery'

  return (
    <div
      className={css({
        textAlign: 'right',
      })}
    >
      <div>
        {isDiscounted && (
          <PriceText price={total} isDiscounted variant="body-md" mr={8} />
        )}
        <PriceText
          price={isDiscounted ? totalAfterDiscount : total}
          variant="heading-sm"
          data-testid="cart-drawer-recipe-total"
        />
      </div>
      <Text
        color="aubergine"
        variant="heading-xxs"
        whiteSpace="nowrap"
        data-testid="cart-drawer-inc-shipping-text"
      >
        {shippingText}
      </Text>
    </div>
  )
}
